import React, { Suspense, lazy } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import zhCN from "antd/locale/zh_CN";
import ErrorBoundary from "./components/ErrorBoundary"; // 导入 ErrorBoundary 组件
import { ConfigProvider } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import "./App.scss";
import sensors from "./utils/sensors";
window.$sensors = sensors;
dayjs.locale("zh-cn");

// 组织架构
const TeamStructure = lazy(() => import("./pages/NewApp/TeamStructure"));
const TeamMemberAdd = lazy(() => import("./pages/NewApp/TeamMemberAdd"));
const TeamMemberDel = lazy(() => import("./pages/NewApp/TeamMemberDel"));

const TeamStruEdit = lazy(() => import("./pages/NewApp/TeamStruEdit"));
const TeamStruAdd = lazy(() => import("./pages/NewApp/TeamStruAdd"));


// 站外转发-团体转发
const TeamCard = lazy(() => import("./pages/NewApp/TeamCard"));
// 站外转发-名片转发
const SuperCard = lazy(() => import("./pages/NewApp/SuperCard"));
// 站外转发-商机转发
const BizOpp = lazy(() => import("./pages/NewApp/BizOpp"));
// b
const Partner = lazy(() => import("./pages/NewApp/Partner"));
// B
const SecretKey = lazy(() => import("./pages/NewApp/SecretKey"));
// 提现
const Withdraw = lazy(() => import("./pages/NewApp/Withdraw"));
// 提现
const Taxes = lazy(() => import("./pages/NewApp/Taxes"));
// 小程序 b&B
const Bandb = lazy(() => import("./pages/NewApp/Bandb"));
// 连连开户
const Lianlian = lazy(() => import("./pages/NewApp/LianlianActive"));
// 连连开户-身份证
const MemberSign = lazy(() => import("./pages/NewApp/MemberSignPage"));
// 提现记录
const WithdrawDetails = lazy(() => import("./pages/NewApp/WithdrawDetails"));
// 开户完成
const SignFinished = lazy(() => import("./pages/NewApp/SignFinished"));


// ai扩充信息
const OrgAi = lazy(() => import("./pages/NewApp/OrgAi"));
const TrainingAIEncyclopedia = lazy(() => import("./pages/NewApp/TrainingAIEncyclopedia"));
// 团体商业报告
const OrgBusinessReport = lazy(() => import("./pages/NewApp/OrgBusinessReport"));
// 个人商业报告
const PersonalBusinessReport = lazy(() => import("./pages/NewApp/PersonalBusinessReport"));



// const SuperCard = lazy(() => import("./pages/ExternalForwarding/SuperCard"));
const XunFuCard = lazy(() => import("./pages/ExternalForwarding/XunfuCard"));

const PdfViewer = lazy(() => import("./pages/PdfViewer/pdfViewer"));
const LinkGuidance = lazy(() => import("./pages/LinkGuidance/linkGuidance"));
// const BusinessCard = lazy(() =>
//   import("./pages/ExternalForwarding/BusinessCard")
// );
const BusinessCardv130 = lazy(() =>
  import("./pages/ExternalForwarding/BusinessCard-v1.3.0")
);
const BusinessCardv131 = lazy(() =>
  import("./pages/ExternalForwarding/BusinessCard-v1.3.1")
);
const OppItem = lazy(() => import("./components/OppItem"));
const OppItemv131 = lazy(() => import("./components/OppItem-v1.3.1"));
// const XunfuOpp = lazy(() => import("./pages/ExternalForwarding/XunfuOpp"));
const XunfuOppv131 = lazy(() =>
  import("./pages/ExternalForwarding/XunfuOpp-v1.3.1")
);

const Register = lazy(() => import("./pages/Information/Register"));
// app-名片
const ElseIdentity = lazy(() => import("./pages/Information/ElseIdentity"));
const ElseIdentityv120 = lazy(() =>
  import("./pages/Information/ElseIdentity-v1.2.0")
);
const Location = lazy(() => import("./pages/Information/City"));
const Locationv130 = lazy(() => import("./pages/Information/JiYu-City"));
// const Title = lazy(() => import("./pages/Information/Title"));
// const Advantage = lazy(() => import("./pages/Information/Advantage"));
const Information = lazy(() => import("./pages/Information/Information"));
const Informationv120 = lazy(() =>
  import("./pages/Information/Information-v1.2.0")
);
const Informationv140 = lazy(() =>
  import("./pages/Information/Information-v1.4.0")
);
const Informationmini = lazy(() =>
  import("./pages/Information/Information-mini")
);
const SearchInput = lazy(() => import("./pages/Information/SearchInput"));
const UserDesc = lazy(() => import("./pages/Information/UserDesc"));

// app-行业自定义
const Industry = lazy(() => import("./pages/Information/Industry"));
const IndustryWithDataSubmit = lazy(() =>
  import("./pages/Information/IndustryWithDataSubmit")
);
const Industryv120 = lazy(() => import("./pages/Information/Industry-v1.2.0"));
const Industryv130 = lazy(() => import("./pages/Information/JiYu-Industry"));

// app-关于询赋-H5
const LianAgreement = lazy(() => import("./pages/UserAgreement/LianlianPermission")); // 连连协议
const UserAgreement = lazy(() => import("./pages/UserAgreement/UserAgreement")); // 用户协议
const UserPrivacy = lazy(() => import("./pages/UserPrivacy/UserPrivacy")); // 隐私协议
const UserCancellation = lazy(() => import("./pages/UserPrivacy/Cancellation")); // 注销协议
const UserSdk = lazy(() => import("./pages/UserPrivacy/UserSdk")); // 第三方信息收集清单
const UserInfoList = lazy(() => import("./pages/User/InfoList")); // 个人信息收集清单
const UserPermission = lazy(() => import("./pages/User/Permission")); // 系统权限
const PayPermission = lazy(() => import("./pages/UserAgreement/PayPermission")); // 会员协议
const OrgPermission = lazy(() => import("./pages/UserAgreement/OrgPermission")); // 组织协议
const MemberPermission = lazy(() => import("./pages/UserAgreement/MemberPermission")); // 签约会员业务协议
const RecommendEngineAgreement = lazy(() =>
  import("./pages/UserAgreement/RecommendEngineAgreement")
); // 推荐引擎服务协议

// app-在线客服-h5
const HelpPage = lazy(() => import("./pages/Help/Help")); // 常见问题
const UserSuggestion = lazy(() => import("./pages/User/Suggestion")); // 意见反馈

// 举报
const Report = lazy(() => import("./pages/Report/Report"));

// 申诉
const Complaints = lazy(() => import("./pages/Complaints/Complaints"));
const ComplaintsDetail = lazy(() => import("./pages/Complaints/Detail"));

// 下载页
const DownLoad = lazy(() => import("./pages/Download/download"));
const DownLoadPro = lazy(() => import("./pages/Download/downloadPro"));

// 关于我们
const AboutUsMini = lazy(() => import("./pages/About/about-mini"));
const AboutUs = lazy(() => import("./pages/About/about"));
const People = lazy(() => import("./pages/About/people"));
const UserManual = lazy(() => import("./pages/About/userManual"));
const UserManualMini = lazy(() => import("./pages/About/userManualMini"));

// 合伙人中心
const Cooperation = lazy(() => import("./pages/Cooperation/cooperation"));
const ElseLink = lazy(() => import("./pages/ElseLink/elseLink"));
// const ElseLinkMini = lazy(() => import("./pages/ElseLink/elseLink-mini"));
const Vertification = lazy(() => import("./pages/Vertification/vertification"));

// 悬赏任务
const RewardTask = lazy(() => import("./pages/NewApp/RewardTask"));
const LingkeVerification = lazy(() =>
  import("./pages/NewApp/LingkeVerification")
);

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <div className="app">
        <HashRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <ErrorBoundary>
            <Suspense>
              <Routes>
                {/* ---------------团体APP--------------- */}
                <Route path="/teamStructure/edit/:orgId" element={<TeamStruEdit />} />
                <Route path="/teamStructure/add/:orgId" element={<TeamStruAdd />} />
                <Route path="/teamMember/add" element={<TeamMemberAdd />} />
                <Route path="/teamMember/del" element={<TeamMemberDel />} />
                <Route path="/teamStructure" element={<TeamStructure />} />

                <Route path="/member-sign/finished/:uid" element={<SignFinished />} />
                <Route path="/withdrawDetails/:uid" element={<WithdrawDetails />} />
                <Route path="/memberSign/:uid" element={<MemberSign />} />
                <Route path="/lianlian/:uid" element={<Lianlian />} />
                <Route path="/taxes/:uid" element={<Taxes />} />
                <Route path="/withdraw/:uid" element={<Withdraw />} />
                <Route path="/bandb" element={<Bandb />} />
                <Route path="/xunfuOpp" element={<BizOpp />} />
                <Route path="/groupInvite" element={<TeamCard />} />
                <Route path="/rewardTask" element={<RewardTask />} />
                <Route path="/lingke/verify" element={<LingkeVerification />} />
                <Route path="/superCard" element={<SuperCard />} />
                <Route path="/partner" element={<Partner />} />
                <Route path="/secretKey" element={<SecretKey />} />
                <Route path="/orgAIEncyclopedia" element={<OrgAi />} />
                <Route path="/personalBusinessReport" element={<PersonalBusinessReport />} />
                <Route path="/orgBusinessReport" element={<OrgBusinessReport />} />
                <Route path="/trainingAIEncyclopedia" element={<TrainingAIEncyclopedia />} />


                {/*--------------- 组织协议-------------*/}
                <Route path="/lianPermission" element={<LianAgreement />} />
                <Route path="/memberPermission/:type" element={<MemberPermission />} />
                <Route path="/organProtocol" element={<OrgPermission />} />
                <Route path="/elseLink" element={<ElseLink />} />
                <Route path="/elseLink/mini" element={<ElseLink />} />
                <Route
                  path="/identityVerification"
                  element={<Vertification />}
                />
                <Route path="/userMenual" element={<UserManual />} />
                <Route path="/userMenual/mini" element={<UserManualMini />} />
                <Route path="/cooperation" element={<Cooperation />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/about/mini" element={<AboutUsMini />} />

                <Route path="/manager/:id" element={<People />} />
                {/*--------------- pdf预览页 -------------*/}
                <Route path="/linkGuidance" element={<LinkGuidance />} />
                {/*--------------- pdf预览页 -------------*/}
                <Route path="/pdfViewer" element={<PdfViewer />} />
                {/*--------------- 注册填写页 -------------*/}
                <Route path="/register" element={<Register />} />
                {/*--------------- 小程序名片 -------------*/}
                {/* <Route path="/businessCard" element={<BusinessCard />} /> */}
                <Route
                  path="/businessCardv1.2.0"
                  element={<BusinessCardv130 />}
                />
                {/* v1.4.0 */}
                {/* <Route path="/superCard" element={<SuperCard />} /> */}
                <Route
                  path="/xunFuCard/:index/:uid/:inviteCode"
                  element={<XunFuCard />}
                />
                {/* v1.3.1 */}
                <Route path="/xunfuOppv1.3.1" element={<XunfuOppv131 />} />
                <Route
                  path="/businessCardv1.3.1"
                  element={<BusinessCardv131 />}
                />
                <Route path="/oppItemv1.3.1/:id" element={<OppItemv131 />} />
                {/* v1.3.0 */}
                <Route path="/oppItem/:id" element={<OppItem />} />
                {/*--------------- 普通资料填写页 -------------*/}
                <Route path="/geneInfo/mini" element={<Informationmini />} />
                <Route path="/geneInfo" element={<Information />} />
                <Route path="/geneInfov1.2.0" element={<Informationv120 />} />
                <Route path="/geneInfov1.4.0" element={<Informationv140 />} />
                {/*--------------- 搜索类弹窗 -------------*/}
                <Route path="/search" element={<SearchInput />} />
                {/*--------------- 用户简介 -------------*/}
                <Route path="/desc" element={<UserDesc />} />
                {/*--------------- 行业自定义 -------------*/}
                <Route path="/industry" element={<Industry />} />
                <Route path="/industryv1.2.0" element={<Industryv120 />} />
                <Route path="/industryv1.3.0" element={<Industryv130 />} />
                <Route
                  path="/industryWithDataSubmit"
                  element={<IndustryWithDataSubmit />}
                />
                {/*--------------- 其他身份 -------------*/}
                <Route path="/identity" element={<ElseIdentity />} />
                <Route path="/identityv1.2.0" element={<ElseIdentityv120 />} />
                {/*--------------- 常住城市 -------------*/}
                <Route path="/location" element={<Location />} />
                <Route path="/locationv1.3.0" element={<Locationv130 />} />

                {/*--------------- 头衔称号 -------------*/}
                {/* <Route path="/title" element={<Title />} /> */}
                {/*--------------- 我的优势  我的资源 -------------*/}
                {/* <Route path="/mycard/:type" element={<Advantage />} /> */}

                {/*--------------- 个人信息收集清单 -------------*/}
                <Route path="/userInfoList" element={<UserInfoList />} />
                {/*--------------- 系统权限 -------------*/}
                <Route path="/userPermission" element={<UserPermission />} />
                {/*--------------- 会员协议 -------------*/}
                <Route path="/payPermission" element={<PayPermission />} />
                <Route
                  path="/recommendEngineAgreement"
                  element={<RecommendEngineAgreement />}
                />

                {/*--------------- 意见反馈 -------------*/}
                <Route path="/suggestion" element={<UserSuggestion />} />
                {/*--------------- 举报 -------------*/}
                <Route path="report" element={<Report />} />
                {/*--------------- 常见问题 -------------*/}
                <Route path="help" element={<HelpPage />} />
                {/*--------------- 注销协议 -------------*/}
                <Route path="cancellation" element={<UserCancellation />} />
                {/*--------------- 用户协议-------------*/}
                <Route path="userAgreement" element={<UserAgreement />} />
                {/*--------------- 隐私协议-------------*/}
                <Route path="userPrivacy" element={<UserPrivacy />} />
                {/*--------------- sdk清单-------------*/}
                <Route path="userSdk" element={<UserSdk />} />
                {/*--------------- 通用下载页-------------*/}
                <Route path="download" element={<DownLoad />} />
                {/*--------------- 邀请下载页-------------*/}
                <Route path="downloadPro" element={<DownLoadPro />} />
                {/*--------------- 申诉 -------------*/}
                <Route
                  path="complaints/detail"
                  element={<ComplaintsDetail />}
                />
                <Route path="complaints" element={<Complaints />} />
                {/*--------------- 其他 -------------*/}
                <Route path="*" element={<div className="dom-404"></div>} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
        </HashRouter>
      </div>
    </ConfigProvider>
  );
}

export default App;
